import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setSceneFactorsOptions } from '../store/options.actions'

export function* getSceneFactorsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getSceneFactorsOptions])
    const { entity } = response
    if (entity) entity.push({ id: 20, name: 'Other', isPN: false, isNV: false, nemsisCode: 2210019 })
    yield put(setSceneFactorsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getSceneFactorsOptions() error: ${e}`))
  }
}

export function* getSceneFactorsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSceneFactorsOptions)
}
